import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpEventType, HttpHeaders, HttpParams, HttpResponse} from '@angular/common/http';
import {environment} from '../environments/environment';
import {Observable, Subject, throwError, BehaviorSubject} from 'rxjs';
import {catchError, tap, map} from 'rxjs/operators';
import {Router} from '@angular/router';
import { ErrorMsgSettings, commonErrorMsg } from './model/error-messages-settings-model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SnackBarInfoComponent } from './common-components/components/snack-bar-info/snack-bar-info.component';
import { SnackBarDangerComponent } from './common-components/components/snack-bar-danger/snack-bar-danger.component';
import { VariantScoreAPIResponse } from './common-components/components/variant-score-info-dialog/variant-score-info-model';
import { LoadPercentage } from './model/load-file-model';
import { GetSpotlightJustification, GetVariantComments, PostSpotlightJustificationResponse, PostVariantCommentsResponse, SpotlightJustificationPost, VariantCommentsPost } from './model/case-model';
import { AuthenticationService } from './apis/authentication.service';
import { GenCCDetails } from './model/common.model';
import { ROHData, ROHParams } from './model/roh-model';

const uploadApi = environment.baseGatewayURL+'upload/file/';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private http: HttpClient, private router: Router, private snackBar: MatSnackBar,private authenticationService: AuthenticationService) {
    window.addEventListener('storage', (event) => {
      if (event.key === 'user') {
          this.router.navigate(['/cases'], { queryParams: { page: 'allcases' } })
          .then(() => {
               window.location.reload();
          });
      }
    });
  }
  
  private version = new BehaviorSubject<string>('');
  version$ = this.version.asObservable();

  public progressLoadFiles = new BehaviorSubject<number>(0);

  public multiFileUpload$ = new BehaviorSubject<LoadPercentage[]>([]);
  public multiFileUploadNames$ = new BehaviorSubject<any[]>([]);

  public isFileUploaded = new BehaviorSubject<string>('No');
  public variantSearch = new BehaviorSubject<string>(null);


     private downLoadPer = new Subject<any>();
     private subject = new Subject<any>();

     private orgChangeSubject = new BehaviorSubject<any>(null);
     public orgID$ = this.orgChangeSubject.asObservable();

     updateOrgID(orgId: any) {
          this.orgChangeSubject.next(orgId);
     }


     addMultiFileProgress(data:LoadPercentage):void{
          const fileItem = this.multiFileUpload$.getValue().find(item => item.file_id == data.file_id);
          if(!fileItem) {
               this.multiFileUpload$.next(this.multiFileUpload$.getValue().concat([data]));
          } else {
               this.multiFileUpload$.next(
                    this.multiFileUpload$.value.map((item: LoadPercentage) =>
                         item.file_id === data.file_id ? data : item 
                    )
               );
          }
     }

     removeMultiFileProgress(id:number):void{
          const progressArray: any[] = this.multiFileUpload$.getValue();
          progressArray.forEach((item, index) => {
               if (item.file_id === id) { progressArray.splice(index, 1); }
          });
     }

     addMultiFileNames(data:string):void{
          const fileItem = this.multiFileUploadNames$.getValue().find(item => item == data);
          if(!fileItem) {
               this.multiFileUploadNames$.next(this.multiFileUploadNames$.getValue().concat([data]));
          } else {
               this.multiFileUploadNames$.next(
                    this.multiFileUploadNames$.value.map((item) =>
                         item === data ? data : item 
                    )
               );
          }
     }

     removeMultiFileNames(name:string):void{
          const progressArray: any[] = this.multiFileUploadNames$.getValue();
          progressArray.forEach((item, index) => {
               if (item === name) { progressArray.splice(index, 1); }
          });
     }

     onDownload(data: any) {
          this.downLoadPer.next({ data });
     }

     getDownloadPer(): Observable<any> {
          return this.downLoadPer.asObservable();
      }

     

  status = {'case_init' : ['usergva', 'health','combined_usergva'], 
            'confirm': ['confirm-variants', 'reviewLog'], 
            // 'vcf_setting':['get_vcf_settings', 'get_sequencing_platforms', 'get_reference_genomes', 'adapter_marker_settings', 'bqsr_settings', 'haplotype_caller_settings', 'vcf_hard_filtering_settings', 'save_vcf_settings']
          };

  sendCaseSelectionDialog(message: any) {
    this.subject.next(message);
  }

  onCaseSelectionDialog(): Observable<any> {
    return this.subject.asObservable();
  }

  get_url(endpoint){
    let base_url = endpoint.split('/',2)[0];
    const end_url = endpoint.split('/',2)[1];
    if(base_url == 'init-api'){
     base_url = 'init-api';
        var url = environment.baseGatewayURL + base_url + '/' + endpoint.split('/')[1] + '/';
        return url;
    } else if(base_url == 'status'){
      if(this.status.case_init.includes(end_url)){
        base_url = 'status_case_init';
        var url = environment.baseGatewayURL + 'case-initiation/' + endpoint.split('/')[1] + '/';
        return url;
      }
      else if(this.status.confirm.includes(end_url)){
        base_url = 'status_confirm';
        var url = environment.baseGatewayURL + 'confirm/' + endpoint.split('/')[1] + '/';
        return url;
      }
      else{
        base_url = 'status_usergva';
        var url = environment.baseGatewayURL + 'usergva/' + endpoint.split('/')[1] + '/';
          return url;
      }
    } else if(base_url == 'user') {
          base_url = 'user';
          var url = environment.baseGatewayURL + 'usermanagement/' + endpoint.split('/')[1] + '/';
          return url;
    } else if(base_url == 'filter_panel') {
          base_url = 'filter_panel';
          var url = environment.baseGatewayURL + 'filter-panel/' + endpoint.split('/')[1] + '/';
          return url;
     } else if(base_url == 'viewset') {
          base_url = 'viewset';
          var url = environment.baseGatewayURL + 'kg-search/' + endpoint.split('/')[1] + '/';
          return url;
     } else if(base_url == 'acmg') {
          base_url = 'acmg';
          var url = environment.baseGatewayURL + 'snv-acmg/' + endpoint.split('/')[1] + '/';
          return url;
     } else if(base_url == 'cnv_acmg') {
          base_url = 'cnv_acmg';
          var url = environment.baseGatewayURL + 'cnv-acmg/' + endpoint.split('/')[1] + '/';
          return url;
     } else if(base_url == 'cnv') {
          base_url = 'cnv';
          var url = environment.baseGatewayURL + 'cnv/' + endpoint.split('/')[1] + '/';
          return url;
     } else if(base_url == 'single') {
          base_url = 'single';
          var url = environment.baseGatewayURL + 'single-variant/' + endpoint.split('/')[1] + '/';
          return url;
     } else if(base_url == 'filters') {
          base_url = 'filters';
          var url = environment.baseGatewayURL + 'filters/' + endpoint.split('/')[1] + '/';
          return url;
     } else if(base_url == 'info') {
          base_url = 'info';
          var url = environment.baseGatewayURL + 'input-info/' + endpoint.split('/')[1] + '/';
          return url;
     } else if(base_url == 'vcf_settings') {
          base_url = 'vcf_settings';
          var url = environment.baseGatewayURL + 'vcf-settings/' + endpoint.split('/')[1] + '/';
          return url;
     } else if(base_url == 'report') {
          base_url = 'report';
          var url = environment.baseGatewayURL + 'reports/' + endpoint.split('/')[1] + '/';
          return url;
     } else if(base_url == 'advanced_settings') {
          base_url = 'advanced_settings';
          var url = environment.baseGatewayURL + 'advanced-settings/' + endpoint.split('/')[1] + '/';
          return url;
     } else if(base_url == 'modify_usergva') {
          base_url = 'modify_usergva';
          var url = environment.baseGatewayURL + 'case-initiation/' + endpoint.split('/')[1] + '/';
          return url;
     } else if(base_url == 'hpo') {
          base_url = 'hpo';
          var url = environment.baseGatewayURL + 'search/' + endpoint.split('/')[1] + '/';
          return url;
     } else if(base_url == 'report') {
          base_url = 'report';
          var url = environment.baseGatewayURL + 'reports/' + endpoint.split('/')[1] + '/';
          return url;
     } 

    var url = environment[base_url] + endpoint.split('/')[1] + '/';
    return url;
  }

  post(endpoint: string, body?: any, headers?: HttpHeaders): Observable<any> {
    const url = this.get_url(endpoint); 
    if (!headers) {
      var headers = new HttpHeaders();
      headers = headers.append('Content-Type', 'application/json');
    }
    return this.http.post(url, body, {headers: headers, withCredentials: true}).pipe(tap((data) => {
    }, (error) => {
      if (error.status === 401) {
        setTimeout(() => {
          this.authenticationService.signout().subscribe((data)=>{
          },(error)=>{});
        }, 5000);
      }
    }));
  }

  confirmVariants(body: any): Observable<any> {
     let header = new HttpHeaders();
     header = header.append('Content-Type', 'text/plain');
     var url = environment.baseGatewayURL + 'confirm/confirm-variants/';
     return this.http.post(url, body, {headers: header, withCredentials: true}).pipe(tap((data) => {
     }, (error) => {
          if (error.status === 401) {
               setTimeout(() => {
                    this.authenticationService.signout().subscribe((data)=>{
                    },(error)=>{});
               }, 5000);
          }
     }));
   }

  getGeneRegions(endpoint, body: any): Observable<any> {
     const url = this.get_url(endpoint);
     let header = new HttpHeaders();
     header = header.append('Content-Type', 'application/json');
     return this.http.post(url, body, {headers: header, withCredentials: true}).pipe(tap((data) => {
     }, (error) => {
          if (error.status === 401) {
               setTimeout(() => {
                 this.authenticationService.signout().subscribe((data)=>{
                 },(error)=>{});
               }, 5000);
          }
     }));
   }

   getCNVKGGeneRegions(body: any): Observable<any> {
     let header = new HttpHeaders();
     header = header.append('Content-Type', 'application/json');
     var url = environment.baseGatewayURL + 'kg-search/split_variant_info/';
     return this.http.post(url, body, {headers: header, withCredentials: true}).pipe(tap((data) => {
     }, (error) => {
          if (error.status === 401) {
               setTimeout(() => {
                 this.authenticationService.signout().subscribe((data)=>{
                 },(error)=>{});
               }, 5000);
          }
     }));
   }


  postProband(endpoint: string, body?: any, headers?: HttpHeaders): Observable<any> {
    // var url = environment.api_url + endpoint;
    const url = this.get_url(endpoint);
    if (!headers) {
      var headers = new HttpHeaders();
      headers = headers.append('Content-Type', 'application/json');
    }
    return this.http.post(url, body, {headers: headers, withCredentials: true}).pipe(tap((data) => {
    }, (error) => {
     if (error.status === 401) {
          setTimeout(() => {
               this.authenticationService.signout().subscribe((data)=>{
               },(error)=>{});
          }, 5000);
     }
    }));
  }

  put(endpoint: string, body?: any, headers?: HttpHeaders): Observable<any> {
    const url = this.get_url(endpoint);
    if (!headers) {
      var headers = new HttpHeaders();
      headers = headers.append('Content-Type', 'application/json');
    }
    return this.http.put(url, body, {headers: headers, withCredentials: true}).pipe(tap((data) => {
    }, (error) => {
      if (error.status === 401) {
        setTimeout(() => {
          this.authenticationService.signout().subscribe((data)=>{
          },(error)=>{});
        }, 5000);
      }
    }));
  }

  get(endpoint): Observable<any> {
    const url = this.get_url(endpoint);
    let header = new HttpHeaders();
     header = header.append('Content-Type', 'application/json');
    return this.http.get(url, {headers: header, withCredentials: true}).pipe(tap((data) => {
    }, (error) => {
     if (error.status === 401) {
          setTimeout(() => {
               this.authenticationService.signout().subscribe((data)=>{
               },(error)=>{});
          }, 5000);
     }
    }));
  }

  

  get_without(endpoint: string): Observable<any> {
    // var url = environment.api_url + endpoint;
    const url = this.get_url(endpoint);
    return this.http.get(url).pipe(tap((data) => {
    }, (error) => {
     if (error.status === 401) {
          setTimeout(() => {
               this.authenticationService.signout().subscribe((data)=>{
               },(error)=>{});
          }, 5000);
     }
    }));
  }

  get_with_params(endpoint: string, params: any): Observable<any> {
    const url = this.get_url(endpoint);
    let header = new HttpHeaders();
     header = header.append('Content-Type', 'application/json');
    return this.http.get(url, {headers: header, withCredentials: true, params: params}).pipe(tap((data) => {
    }, (error) => {
     if (error.status === 401) {
          setTimeout(() => {
               this.authenticationService.signout().subscribe((data)=>{
               },(error)=>{});
          }, 5000);
     }
    }));
  }

  delete(endpoint, params?: any,): Observable<any> {
    const url = this.get_url(endpoint);
    var headers = new HttpHeaders(); 
    headers = headers.append('Content-Type', 'application/json');
    return this.http.delete(url, {headers: headers, withCredentials: true, params: params}).pipe(tap((data) => {
    }, (error) => {
      if (error.status === 401) {
        setTimeout(() => {
          this.authenticationService.signout().subscribe((data)=>{
          },(error)=>{});
        }, 5000);
      }
    }));
  }

  get_authorization(endpoint, caseId, gvaId) {
    const url = this.get_url(endpoint);
    let header = new HttpHeaders();
    header = header.append('Content-Type', 'application/json');
    let param = new HttpParams();
    param = param.append('case_id', caseId.toString());
    param = param.append('job_id', gvaId.toString());
    return this.http.get(url, {headers: header, withCredentials: true, params: param}).pipe(tap((data) => {
    }, (error) => {
      if (error.status === 401) {
        setTimeout(() => {
          this.authenticationService.signout().subscribe((data)=>{
          },(error)=>{});
        }, 5000);
      }
    }));
  }

  uploadUserImage(imageToUpload: any, headers: HttpHeaders, endpoint, org_id?, user_id?){
     let header = new HttpHeaders();
     header = header.append('Content-Type', 'application/json');
     const url = this.get_url(endpoint);
     const formData : FormData = new FormData();
    formData.append('file', imageToUpload, imageToUpload.name);
    formData.append('user_id', user_id.toString());
    formData.append('org_id', org_id.toString());
     return this.http.post(url, formData, {headers: header, withCredentials: true}).pipe(tap((data) => {
    },
    (error) =>{
     if (error.status === 401) {
          setTimeout(() => {
               this.authenticationService.signout().subscribe((data)=>{
               },(error)=>{});
          }, 5000);
     }
    }
    ))
  }

  getUserImage(endpoint, headers: HttpHeaders, org_id?, user_id?): Observable<any>{
    const url = this.get_url(endpoint);
     let header = new HttpHeaders();
     header = header.append('Content-Type', 'application/json');
     let param = new HttpParams();
     if(org_id && user_id && org_id != '' && user_id != '') {
          param = param.append('user_id', user_id.toString());
          param = param.append('org_id', org_id.toString());
     }
     return this.http.get(url, {headers: header, withCredentials: true, params: param}).pipe(tap((data) => {

    },
    (error)=>{
     if (error.status === 401) {
          setTimeout(() => {
               this.authenticationService.signout().subscribe((data)=>{
               },(error)=>{});
          }, 5000);
     }
    }
    )
)
  }

  uploadFile(fileToUpload: any, endpoint: string, headers: HttpHeaders, org_id?, user_id?, analysis_type?) {

    let header = new HttpHeaders();
    const url = this.get_url(endpoint);
    const formData: FormData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    if (analysis_type) {

      formData.append('analysis_type', analysis_type);
    }
    formData.append('org_id', org_id);
    formData.append('user_id', user_id);
    return this.http.post(url, formData, {
      headers: headers,
      reportProgress: true,
      observe: 'events',
    }).pipe(tap((data) => {
    }, (error) => {
     if (error.status === 401) {
          setTimeout(() => {
               this.authenticationService.signout().subscribe((data)=>{
               },(error)=>{});
          }, 5000);
     }
    }));
  }

  postFile(endpoint: any, body, headers: HttpHeaders): Observable<any> {
    // var url = environment.api_url + endpoint;
    const url = this.get_url(endpoint);
    headers = headers.append('content-type', 'application/json');
    return this.http.post(url, body, {
      headers: headers,
      responseType: 'text',
    }).pipe(tap((data) => {
    }, (error) => {
     if (error.status === 401) {
          setTimeout(() => {
               this.authenticationService.signout().subscribe((data)=>{
               },(error)=>{});
          }, 5000);
     }
    }));
  }

  get_with_headers_params(
    endpoint: string,
    header: HttpHeaders,
    params: HttpParams
  ): Observable<any> {
    const url = this.get_url(endpoint);
    var headers = new HttpHeaders(); 
    headers = headers.append('Content-Type', 'application/json');
    return this.http.get(url, {headers: headers, withCredentials: true, params: params}).pipe(tap((data) => {
    }, (error) => {
      if (error.status === 401) {
        setTimeout(() => {
          this.authenticationService.signout().subscribe((data)=>{
          },(error)=>{});
        }, 5000);
      }
    }));
  }

  get_with_headers(
    endpoint: string,
    header: HttpHeaders,
  ): Observable<any> {
     let headers = new HttpHeaders();
     headers = headers.append('Content-Type', 'application/json');
    const url = this.get_url(endpoint);
    return this.http.get(url, {headers: headers, withCredentials: true}).pipe(tap((data) => {
    }, (error) => {
     if (error.status === 401) {
          setTimeout(() => {
               this.authenticationService.signout().subscribe((data)=>{
               },(error)=>{});
          }, 5000);
     }
    }));
  }

  getACMGSEFindings (params: HttpParams): Observable<any> {
     let header = new HttpHeaders();
     header = header.append('Content-Type', 'application/json');
     var url = environment.baseGatewayURL + 'filters/acmg_sf/';
     return this.http.get(url, {headers: header, withCredentials: true, params: params}).pipe(tap((data) => {
     }, (error) => {
          if (error.status === 401) {
               setTimeout(() => {
                 this.authenticationService.signout().subscribe((data)=>{
                 },(error)=>{});
               }, 5000);
             }
     }));
   }

   getCaseCount (url: string, params: HttpParams): Observable<any> {
     let header = new HttpHeaders();
     header = header.append('Content-Type', 'application/json');
     var url = environment.baseGatewayURL + url;
     return this.http.get(url, {headers: header, withCredentials: true, params: params}).pipe(tap((data) => {
     }, (error) => {
          if (error.status === 401) {
               setTimeout(() => {
                 this.authenticationService.signout().subscribe((data)=>{
                 },(error)=>{});
               }, 5000);
             }
     }));
   }

   getPseudoGeneInfo (payload: any): Observable<any> {
     let header = new HttpHeaders();
     header = header.append('Content-Type', 'application/json');
     var url = environment.baseGatewayURL + 'filters/get_pseudogene_info/';
     return this.http.post(url, payload, {headers: header, withCredentials: true}).pipe(tap((data) => {
     }, (error) => {
          if (error.status === 401) {
               setTimeout(() => {
                 this.authenticationService.signout().subscribe((data)=>{
                 },(error)=>{});
               }, 5000);
             }
     }));
   }

   getKGTranscriptInfo (payload: any): Observable<any> {
     let header = new HttpHeaders();
     header = header.append('Content-Type', 'application/json');
     var url = environment.baseGatewayURL + 'kg-search/transcript_info/';
     return this.http.post(url, payload, {headers: header, withCredentials: true}).pipe(tap((data) => {
     }, (error) => {
          if (error.status === 401) {
               setTimeout(() => {
                 this.authenticationService.signout().subscribe((data)=>{
                 },(error)=>{});
               }, 5000);
          }
     }));
   }

     downloadVariants(body: any): Observable<any> {
          let header = new HttpHeaders();
          header = header.append('Content-Type', 'application/json');
          var url = environment.baseGatewayURL + 'filter-panel/download_variants/';
          return this.http.post(url, body, {
               headers: header, withCredentials: true, responseType: "text"
               }).pipe(tap((data) => {
               }, (error) => {
                    if (error.status === 401) {
                         setTimeout(() => {
                              this.authenticationService.signout().subscribe((data)=>{
                              },(error)=>{});
                         }, 5000);
                    }
               }));
     }

     downloadFilteredVariants(body: any, headers: HttpHeaders): Observable<any> {
          var url = environment.baseGatewayURL + 'filter-panel/download_filtered/';
          return this.http.post(url, body, {
               headers: headers, withCredentials: true, responseType: "text"
               }).pipe(tap((data) => {
               }, (error) => {
                    if (error.status === 401) {
                         setTimeout(() => {
                              this.authenticationService.signout().subscribe((data)=>{
                              },(error)=>{});
                         }, 5000);
                    }
               }));
     }

     getSuperUserList(): Observable<any> {
          let header = new HttpHeaders();
          header = header.append('Content-Type', 'application/json');
          const url = environment.baseGatewayURL+'init-api/superuser_list/';
          return this.http.get(url, {headers: header, withCredentials: true}).pipe(tap((data) => {
          }, (error) => {
               if (error.status === 401) {
                    setTimeout(() => {
                         this.authenticationService.signout().subscribe((data)=>{
                         },(error)=>{});
                    }, 5000);
               }
          }));
     }

     getTopLevelGenePanel(params?: HttpParams): Observable<any> {
          let header = new HttpHeaders();
          header = header.append('Content-Type', 'application/json');
          const url = environment.baseGatewayURL+'init-api/retrieve_gene_panels/';
          if(!params) {
               return this.http.get(url, {headers: header, withCredentials: true,  params}).pipe(tap((data) => {
               }, (error) => {
               }));
          } else {
               let option = {
                    headers: header,
                    withCredentials: true,
                    params: params
               }
               return this.http.get(url, option).pipe(tap((data) => {
               }, (error) => {
                    if (error.status === 401) {
                         setTimeout(() => {
                              this.authenticationService.signout().subscribe((data)=>{
                              },(error)=>{});
                         }, 5000);
                    }
               }));
          }
     }

     getGenePanelInfo(params: HttpParams): Observable<any> {
          let header = new HttpHeaders();
          header = header.append('Content-Type', 'application/json');
          const url = environment.baseGatewayURL+'filter-panel/retrieve_gene_panel_info/';
          let option = {
               headers: header,
               withCredentials: true,
               params: params
          }
          return this.http.get(url, option).pipe(tap((data) => {
          }, (error) => {
               if (error.status === 401) {
                    setTimeout(() => {
                         this.authenticationService.signout().subscribe((data)=>{
                         },(error)=>{});
                    }, 5000);
               }
          }));
     }

     getSplitLevelDiseaseInher(payLoad: any): Observable<any> {
          let header = new HttpHeaders();
          header = header.append('Content-Type', 'application/json');
          const url = environment.baseGatewayURL+'reports/cnv_updated_report/';
          return this.http.post(url, payLoad, {headers: header,withCredentials: true}).pipe(tap((data) => {
          }, (error) => {
               if (error.status === 401) {
                    setTimeout(() => {
                      this.authenticationService.signout().subscribe((data)=>{
                      },(error)=>{});
                    }, 5000);
                  }
          }));
     }

     downloadURLDiscardedVariants(body: any): Observable<any> {
          let header = new HttpHeaders();
          header = header.append('Content-Type', 'application/json');
          var url = environment.baseGatewayURL + 'filter-panel/discard_variants/';
          return this.http.post(url, body, {
               headers: header, withCredentials: true}).pipe(tap((data) => {
               }, (error) => {
                    if (error.status === 401) {
                         setTimeout(() => {
                              this.authenticationService.signout().subscribe((data)=>{
                              },(error)=>{});
                         }, 5000);
                    }
               }));
     }

     downloadVCF_BAM(body: any, format: string): Observable<any> {
          if (format === 'BAM' ) {
               var url = environment.baseGatewayURL + 'filter-panel/download_bam/';
          } else if (format === 'BAI' ) {
               var url = environment.baseGatewayURL + 'filter-panel/download_bai/';
          } else if (format === 'VCF' ) {
               var url = environment.baseGatewayURL + 'filter-panel/download_vcf/';
          }
          let header = new HttpHeaders();
          header = header.append('Content-Type', 'application/json');
          return this.http.post(url, body, {
               headers: header, withCredentials: true}).pipe(tap((data) => {
               }, (error) => {
                    if (error.status === 401) {
                         setTimeout(() => {
                              this.authenticationService.signout().subscribe((data)=>{
                              },(error)=>{});
                         }, 5000);
                    }
               }));
     }

     download_BED(body: any): Observable<any> {
          var url = environment.baseGatewayURL + 'filter-panel/download_bed/';
          let header = new HttpHeaders();
          header = header.append('Content-Type', 'application/json');
          return this.http.post(url, body, {
               headers: header, withCredentials: true}).pipe(tap((data) => {
               }, (error) => {
                    if (error.status === 401) {
                         setTimeout(() => {
                              this.authenticationService.signout().subscribe((data)=>{
                              },(error)=>{});
                         }, 5000);
                    }
               }));
     }

     downloadVCFAPI(body: any, headers: HttpHeaders): Observable<any> {
          let header = new HttpHeaders();
          header = header.append('Content-Type', 'application/json');
          var url = environment.baseGatewayURL + 'filter-panel/download_vcf/';
          return this.http.post(url, body, {
               headers: header, withCredentials: true, responseType: "blob", observe: 'events',reportProgress: true,
               }).pipe(tap((data) => {
               }, (error) => {
                    if (error.status === 401) {
                         setTimeout(() => {
                              this.authenticationService.signout().subscribe((data)=>{
                              },(error)=>{});
                         }, 5000);
                    }
               }));
     }

     downloadVCF(body: any, headers: HttpHeaders) {
          this.snackBar.openFromComponent(SnackBarInfoComponent, {
               data: { msg: 'Download in progress' },
               panelClass: 'snackBarInfo',
               duration: 10000
          });
          this.downloadVCFAPI(
               body,
               headers
          )
          .pipe(
               tap(event => {
                    if (event.type === HttpEventType.Sent) {
                         
                    }
                    if (event.type === HttpEventType.ResponseHeader) {
                         
                    }
                    if (event.type === HttpEventType.DownloadProgress) {
                         let downloadPer = Math.round(100 * event.loaded / event.total);
                         this.onDownload({
                              status: 'In progress',
                              percentage: downloadPer,
                              caseId: body.case_id
                         })
                    }
                    if (event.type === HttpEventType.Response) {
                         const contentDispositionHeader: string = event.headers.get('Content-Disposition');
                         const parts: string[] = contentDispositionHeader.split(';');
                         const filename = parts[1].split('=')[1];
                         const blob = new Blob([event.body], {
                              type: 'application/zip'
                         });
                         const url = window.URL.createObjectURL(blob);
                         var anchor = document.createElement("a");
                         if(filename) {
                              anchor.download = filename;
                         } else {
                              anchor.download = body.case_id+'.csv.gz';
                         }
                         anchor.href = url;
                         anchor.click();
                         this.onDownload({
                              status: 'Completed',
                              percentage: '100',
                              caseId: body.case_id
                         })
                    }
               }),
               catchError((error: HttpErrorResponse) => {
                    if (error instanceof HttpErrorResponse) {
                         let errorMessage = 'Something went wrong while processing your request. Try again in a few minutes or contact System Support';
                         error.error.text().then (
                              (msg) => {
                                   errorMessage = JSON.parse(msg).user_specific_message;
                                   this.snackBar.openFromComponent(SnackBarDangerComponent, {
                                        data: { msg: errorMessage},
                                        panelClass: 'snackBarDanger',
                                        duration: ErrorMsgSettings.duration
                                   });
                              }
                         )
                         return throwError(errorMessage);
                    } else {
                         this.snackBar.openFromComponent(SnackBarDangerComponent, {
                              data: { msg: 'An unexpected error occurred:'},
                              panelClass: 'snackBarDanger',
                              duration: ErrorMsgSettings.duration
                         });
                    }
                    return throwError(error);
               })
          )
          .subscribe(
               () => {
                    
               },
               (error) => {
                    this.snackBar.openFromComponent(SnackBarDangerComponent, {
                         data: { msg: 'An unexpected error occurred:'},
                         panelClass: 'snackBarDanger',
                         duration: ErrorMsgSettings.duration
                    });
                    if (error.status === 401) {
                         setTimeout(() => {
                              this.authenticationService.signout().subscribe((data)=>{
                              },(error)=>{});
                         }, 5000);
                    }
               }
          );
     }

     downloadPGXVariants(body: any): Observable<any> {
          let header = new HttpHeaders();
          header = header.append('Content-Type', 'application/json');
          var url = environment.baseGatewayURL + 'filter-panel/download_pgx/';
          return this.http.post(url, body, {
               headers: header, withCredentials: true, responseType: "text"
               }).pipe(tap((data) => {
               }, (error) => {
                    if (error.status === 401) {
                         setTimeout(() => {
                              this.authenticationService.signout().subscribe((data)=>{
                              },(error)=>{});
                         }, 5000);
                    }
               }));
     }

     consolidatedDiseases(params: HttpParams): Observable<any> {
          let header = new HttpHeaders();
          header = header.append('Content-Type', 'application/json');
          var url = environment.baseGatewayURL + 'filter-panel/consolidated_diseases/';
          return this.http.get(url, {headers: header, withCredentials: true, params: params}).pipe(tap((data) => {
          }, (error) => {
               if (error.status === 401) {
                    setTimeout(() => {
                         this.authenticationService.signout().subscribe((data)=>{
                         },(error)=>{});
                    }, 5000);
               }
          }));
     }

     getMatchedDiseasePhenotypes(body: any): Observable<any> {
          let header = new HttpHeaders();
          header = header.append('Content-Type', 'application/json');
          const url = environment.baseGatewayURL + 'filter-panel/get_matched_disease_phenotypes/'
          return this.http.post<any>(url, body, {headers: header, withCredentials: true}).pipe(
               map((res) => res),
          );
     }

     getGenCCDetails(params: HttpParams, headers: HttpHeaders): Observable<GenCCDetails> {
          var url = environment.baseGatewayURL + 'filter-panel/get_gencc_details/';
          return this.http.get<GenCCDetails>(url, {headers: headers, withCredentials: true, params: params}).pipe(tap((data) => {
          }, (error) => {
            if (error.status === 401) {
              setTimeout(() => {
                this.router.navigate(['/login']);
              }, 5000);
            }
          }));
     }
  
     deleteCase(params: HttpParams, body) {
          const url = environment.baseGatewayURL + 'usergva/delete_case/';
          var headers = new HttpHeaders(); 
          headers = headers.append('Content-Type', 'application/json');
          return this.http.delete(url, {headers: headers, withCredentials: true, params: params}).pipe(tap((data) => {
          }, (error) => {
               if (error.status === 401) {
                    setTimeout(() => {
                         this.authenticationService.signout().subscribe((data)=>{
                         },(error)=>{});
                    }, 5000);
               }
          }));
     }

     getFrequencyOfVariants(): Observable<any>{
      let header = new HttpHeaders();
      header = header.append('Content-Type', 'application/json');
      const url = environment.baseGatewayURL + "init-api/get_frequency_of_variants/"
      return this.http.get(url, {headers: header, withCredentials: true}).pipe(tap((data) => {
      }, (error) => {
          if (error.status === 401) {
               setTimeout(() => {
                    this.authenticationService.signout().subscribe((data)=>{
                    },(error)=>{});
               }, 5000);
          }
      }));
     }

     getPhenoTypesTree(body: any): Observable<any> {
          let header = new HttpHeaders();
          header = header.append('Content-Type', 'application/json');
          const url = environment.baseGatewayURL + 'filter-panel/phenotype_tree/'
          return this.http.post<any>(url, body, {headers: header, withCredentials: true}).pipe(
               map((res) => res),
          );
     }

     saveSingleVariant(payload: any): Observable<any> {
          let header = new HttpHeaders();
          header = header.append('Content-Type', 'text/plain');
          var url = environment.baseGatewayURL + 'single-variant/single_variant_save/';
          return this.http.post(url, payload, {headers: header, withCredentials: true}).pipe(tap((data) => {
          }, (error) => {
               if (error.status === 401) {
                    setTimeout(() => {
                         this.authenticationService.signout().subscribe((data)=>{
                         },(error)=>{});
                    }, 5000);
               }
          }));
     }

     getZygosity(): Observable<any> {
          const url = environment.baseGatewayURL + 'single-variant/zygosity/';
          let header = new HttpHeaders();
          header = header.append('Content-Type', 'application/json');
          return this.http.get(url, {headers: header, withCredentials: true}, ).pipe(tap((data)  => {
          }, (error) => {
               if (error.status === 401) {
                    setTimeout(() => {
                         this.authenticationService.signout().subscribe((data)=>{
                         },(error)=>{});
                    }, 5000);
               }
          }));
     }

     variantInfo(body?: any): Observable<any> {
          const url = environment.baseGatewayURL + 'kg-search/variant_info/'
          if (!headers) {
            var headers = new HttpHeaders();
            headers = headers.append('Content-Type', 'application/json');
          }
          return this.http.post(url, body, {headers: headers, withCredentials: true}).pipe(tap((data) => {
          }, (error) => {
               if (error.status === 401) {
                    setTimeout(() => {
                      this.authenticationService.signout().subscribe((data)=>{
                      },(error)=>{});
                    }, 5000);
               }
          }));
     }

     getKGMatchedPhenotypes(body: any, headers: HttpHeaders): Observable<any> {
          const url = environment.viewset + 'matched_phenotype/';
          return this.http.post(url, body, {headers: headers}).pipe(tap((data) => {
          }, (error) => {
               if (error.status === 401) {
                    setTimeout(() => {
                         this.authenticationService.signout().subscribe((data)=>{
                         },(error)=>{});
                    }, 5000);
               }
          }));
     }

     transactionCheck(headers: HttpHeaders, params:HttpParams ): Observable<{allowed: boolean}> { 
          let header = new HttpHeaders();
          header = header.append('Content-Type', 'application/json');
          const url = environment.baseGatewayURL + 'case-initiation/allow-transaction/';
          return this.http.get<{allowed: boolean}>(url, {headers: header,withCredentials: true, params}).pipe(tap((data: {allowed: boolean}) => {
          }, (error) => {
               if (error.status === 401) {
                    setTimeout(() => {
                      this.authenticationService.signout().subscribe((data)=>{
                      },(error)=>{});
                    }, 5000);
                  }
          }));
     }

     getVariantScore(payLoad: any): Observable<VariantScoreAPIResponse[]> {
          let header = new HttpHeaders();
          header = header.append('Content-Type', 'application/json');
          var url = environment.baseGatewayURL + 'filter-panel/variant_score/';
          return this.http.post(url, payLoad, {headers: header, withCredentials: true}).pipe(tap((data: VariantScoreAPIResponse[]) => {
          }, (error) => {
               if (error.status === 401) {
                    setTimeout(() => {
                         this.authenticationService.signout().subscribe((data)=>{
                         },(error)=>{});
                    }, 5000);
               }
          }));
     }

     uploadCleanUp(payLoad: string): Observable<any> {
          let header = new HttpHeaders();
          header = header.append('Content-Type', 'application/json');
          let params = new HttpParams();
          params = params.append('file_name', payLoad);
          let option = {
               headers: header,
               withCredentials: true,
               params: params
          }
          return this.http.delete(`${uploadApi}upload_clean_up/`, option).pipe(tap((data) => {
          }, (error) => {
               if (error.status === 401) {
                    setTimeout(() => {
                      this.authenticationService.signout().subscribe((data)=>{
                      },(error)=>{});
                    }, 5000);
               }
          }));
     }

     getVersion(): Observable<{version: string}> {
          const url = environment.version + 'version/';
          let params = new HttpParams();
          params = params.append('application_id', '1');
          let option = {
               withCredentials: true,
               params: params
          }
          return this.http.get<{version: string}>(url, option).pipe(tap((data) => {
          }, (error) => {
            
          }));
     }

     getDiseaseAssoc(header: HttpHeaders, body: any): Observable<any> {
          const url = environment.baseGatewayURL + 'filter-panel/get_disease_assoc/'
          return this.http.post<any>(url, body, {headers: header, withCredentials: true}).pipe(
               map((res) => res),
          );
     }

     getPhenoTypeMatchedDetails(header: HttpHeaders, body: any): Observable<any> {
          const url = environment.baseGatewayURL + 'filter-panel/matched_phenotypes/'
          return this.http.post<any>(url, body, {headers: header, withCredentials: true}).pipe(
               map((res) => res),
          );
     }

     appVersion(value: string) {
          this.version.next(value); 
     }

     downloadQC_Report(body: any, headers: HttpHeaders): Observable<{response: string}> {
          var url = environment.baseGatewayURL + 'filter-panel/download_qc/';
          return this.http.post<{response: string}>(url, body, {
               headers: headers, withCredentials: true}).pipe(tap((data) => {
               }, (error) => {
                    if (error.status === 401) {
                         setTimeout(() => {
                              this.authenticationService.signout().subscribe((data)=>{
                              },(error)=>{});
                         }, 5000);
                    }
               }));
     }

     viewQC_Report(body: any, headers: HttpHeaders): Observable<{response: string}> {
          var url = environment.baseGatewayURL + 'filter-panel/view_qc/';
          return this.http.post<{response: string}>(url, body, {
               headers: headers, withCredentials: true}).pipe(tap((data) => {
               }, (error) => {
                    if (error.status === 401) {
                         setTimeout(() => {
                              this.authenticationService.signout().subscribe((data)=>{
                              },(error)=>{});
                         }, 5000);
                    }
               }));
     }

     downloadACMGSF(body: any, headers: HttpHeaders): Observable<any> {
          var url = environment.baseGatewayURL + 'filter-panel/download_sf/';
          return this.http.post(url, body, {
               headers: headers, withCredentials: true}).pipe(tap((data) => {
               }, (error) => {
                    if (error.status === 401) {
                         setTimeout(() => {
                              this.authenticationService.signout().subscribe((data)=>{
                              },(error)=>{});
                         }, 5000);
                    }
               }));
     }

     getManualSpotLightJustification (params: HttpParams, headers: HttpHeaders): Observable<GetSpotlightJustification> {
          var url = environment.baseGatewayURL + 'filter-panel/spotlight_change/';
          return this.http.get<GetSpotlightJustification>(url, {headers: headers, withCredentials: true, params: params}).pipe(tap((data) => {
          }, (error) => {
               if (error.status === 401) {
                    setTimeout(() => {
                         this.authenticationService.signout().subscribe((data)=>{
                         },(error)=>{});
                    }, 5000);
               }
          }));
     }

     postManualSpotLightJustification(body: SpotlightJustificationPost, headers: HttpHeaders): Observable<PostSpotlightJustificationResponse> {
          var url = environment.baseGatewayURL + 'filter-panel/spotlight_change/';
          return this.http.post<PostSpotlightJustificationResponse>(url, body, {
               headers: headers, withCredentials: true}).pipe(tap((data) => {
               }, (error) => {
                    if (error.status === 401) {
                         setTimeout(() => {
                           this.authenticationService.signout().subscribe((data)=>{
                           },(error)=>{});
                         }, 5000);
                       }
               }));
     }

     getVariantComments (params: HttpParams, headers: HttpHeaders): Observable<GetVariantComments> {
          var url = environment.baseGatewayURL + 'filter-panel/variant_comment/';
          return this.http.get<GetVariantComments>(url, {headers: headers, withCredentials: true, params: params}).pipe(tap((data) => {
          }, (error) => {
               if (error.status === 401) {
                    setTimeout(() => {
                      this.authenticationService.signout().subscribe((data)=>{
                      },(error)=>{});
                    }, 5000);
                  }
          }));
     }

     postVariantComments(body: VariantCommentsPost, headers: HttpHeaders): Observable<PostVariantCommentsResponse> {
          var url = environment.baseGatewayURL + 'filter-panel/variant_comment/';
          return this.http.post<PostVariantCommentsResponse>(url, body, {
               headers: headers, withCredentials: true}).pipe(tap((data) => {
               }, (error) => {
                    if (error.status === 401) {
                         setTimeout(() => {
                              this.authenticationService.signout().subscribe((data)=>{
                              },(error)=>{});
                         }, 5000);
                    }
               }));
     }

     getNotifications(
          endpoint: string,
        ): Observable<any> {
          var headers = new HttpHeaders(); 
          headers = headers.append('Content-Type', 'application/json');
          const url = environment.baseGatewayURL+endpoint;
          return this.http.get(url, {headers: headers, withCredentials: true}).pipe(tap((data) => {
          }, (error) => {
               if (error.status === 401) {
                    setTimeout(() => {
                         this.authenticationService.signout().subscribe((data)=>{
                         },(error)=>{});
                    }, 5000);
               }
          }));
     }

     getROH(payLoad: ROHParams): Observable<string> {
          var url = environment.baseGatewayURL + 'init-api/view_roh/';
          var headers = new HttpHeaders(); 
          headers = headers.append('Content-Type', 'application/json');
          return this.http.post<string>(url, payLoad, {headers: headers,withCredentials: true}).pipe(tap((data) => {
          }, (error) => {
               if (error.status === 401) {
                    setTimeout(() => {
                      this.authenticationService.signout().subscribe((data)=>{
                      },(error)=>{});
                    }, 5000);
                  }
          }));
     }

     rescoreVariants(body: any): Observable<any> {
          let header = new HttpHeaders();
          header = header.append('Content-Type', 'application/json');
          const url = environment.baseGatewayURL + 'filter-panel/rescore_variants/'
          return this.http.post<any>(url, body, {headers: header, withCredentials: true}).pipe(
               map((res) => res),
          );
     }

     createNamedFilter(payLoad: any): Observable<any> {
          let header = new HttpHeaders();
          header = header.append('Content-Type', 'application/json');
          var url = environment.baseGatewayURL + 'filter-panel/namedfilter/create/';
          return this.http.post(url, payLoad, {headers: header, withCredentials: true}).pipe(tap((data: any) => {
          }, (error) => {
               if (error.status === 401) {
                    setTimeout(() => {
                         this.authenticationService.signout().subscribe((data)=>{
                         },(error)=>{});
                    }, 5000);
               }
          }));
     }

     getNamedFilters(param: HttpParams): Observable<any> {
          let header = new HttpHeaders();
          header = header.append('Content-Type', 'application/json');
          const url = environment.baseGatewayURL+'filter-panel/namedfilters/';
          let option = {
               headers: header,
               withCredentials: true,
               params: param
          }
          return this.http.get(url, option).pipe(tap((data) => {
          }, (error) => {
               if (error.status === 401) {
                    setTimeout(() => {
                         this.authenticationService.signout().subscribe((data)=>{
                         },(error)=>{});
                    }, 5000);
               }
          }));
     }

     getNamedFilter(param: HttpParams): Observable<any> {
          let header = new HttpHeaders();
          header = header.append('Content-Type', 'application/json');
          const url = environment.baseGatewayURL+'filter-panel/namedfilter/';
          let option = {
               headers: header,
               withCredentials: true,
               params: param
          }
          return this.http.get(url, option).pipe(tap((data) => {
          }, (error) => {
               if (error.status === 401) {
                    setTimeout(() => {
                         this.authenticationService.signout().subscribe((data)=>{
                         },(error)=>{});
                    }, 5000);
               }
          }));
     }

     deleteNamedFilter(params: HttpParams) {
          const url = environment.baseGatewayURL + 'filter-panel/namedfilter/delete/';
          var headers = new HttpHeaders(); 
          headers = headers.append('Content-Type', 'application/json');
          return this.http.delete(url, {headers: headers, withCredentials: true, params: params}).pipe(tap((data: any) => {
          }, (error) => {
               if (error.status === 401) {
                    setTimeout(() => {
                         this.authenticationService.signout().subscribe((data)=>{
                         },(error)=>{});
                    }, 5000);
               }
          }));
     }

     updateNamedFilter(payLoad: any): Observable<any> {
          let header = new HttpHeaders();
          header = header.append('Content-Type', 'application/json');
          var url = environment.baseGatewayURL + 'filter-panel/namedfilter/update/';
          return this.http.put(url, payLoad, {headers: header, withCredentials: true}).pipe(tap((data: any) => {
          }, (error) => {
               if (error.status === 401) {
                    setTimeout(() => {
                         this.authenticationService.signout().subscribe((data)=>{
                         },(error)=>{});
                    }, 5000);
               }
          }));
     }

     namedFilterStats(payLoad: any): Observable<any> {
          let header = new HttpHeaders();
          header = header.append('Content-Type', 'application/json');
          var url = environment.baseGatewayURL + 'filter-panel/namedfilter/stats/';
          return this.http.post(url, payLoad, {headers: header, withCredentials: true}).pipe(tap((data: any) => {
          }, (error) => {
               if (error.status === 401) {
                    setTimeout(() => {
                         this.authenticationService.signout().subscribe((data)=>{
                         },(error)=>{});
                    }, 5000);
               }
          }));
     }

     getCaseDetails(param: HttpParams): Observable<any> {
          let header = new HttpHeaders();
          header = header.append('Content-Type', 'application/json');
          const url = environment.baseGatewayURL+'init-api/vcf_cases/';
          let option = {
               headers: header,
               withCredentials: true,
               params: param
          }
          return this.http.get(url, option).pipe(tap((data) => {
          }, (error) => {
               if (error.status === 401) {
                    setTimeout(() => {
                         this.authenticationService.signout().subscribe((data)=>{
                         },(error)=>{});
                    }, 5000);
               }
          }));
     }

     manualLinking(payLoad: any): Observable<any> {
          let header = new HttpHeaders();
          header = header.append('Content-Type', 'application/json');
          var url = environment.baseGatewayURL + 'init-api/manual_linking/';
          return this.http.post(url, payLoad, {headers: header, withCredentials: true}).pipe(tap((data: any) => {
          }, (error) => {
               if (error.status === 401) {
                    setTimeout(() => {
                         this.authenticationService.signout().subscribe((data)=>{
                         },(error)=>{});
                    }, 5000);
               }
          }));
     }

     getPhenotypeFromTxtOrPDF(payLoad: FormData): Observable<any> {
          var url = environment.baseGatewayURL + 'search/auto-hpo-extractor/';
          return this.http.post(url, payLoad, {withCredentials: true}).pipe(tap((data: any) => {
          }, (error) => {
               if (error.status === 401) {
                    setTimeout(() => {
                         this.authenticationService.signout().subscribe((data)=>{
                         },(error)=>{});
                    }, 5000);
               }
          }));
     }

     getQCTooltips(): Observable<any>{
          let header = new HttpHeaders();
          header = header.append('Content-Type', 'application/json');
          const url = environment.baseGatewayURL + "init-api/get_qc_attributes/"
          return this.http.get(url, {headers: header, withCredentials: true}).pipe(tap((data) => {
          }, (error) => {
              if (error.status === 401) {
                   setTimeout(() => {
                        this.authenticationService.signout().subscribe((data)=>{
                        },(error)=>{});
                   }, 5000);
              }
          }));
     }

     updatePersonalInfo(payLoad: any): Observable<any> {
          let header = new HttpHeaders();
          header = header.append('Content-Type', 'application/json');
          var url = environment.baseGatewayURL + 'init-api/update_case_summary/';
          return this.http.put(url, payLoad, {headers: header, withCredentials: true}).pipe(tap((data: any) => {
          }, (error) => {
               if (error.status === 401) {
                    setTimeout(() => {
                         this.authenticationService.signout().subscribe((data)=>{
                         },(error)=>{});
                    }, 5000);
               }
          }));
     }

}

